import React from 'react'

import 'react-datepicker/dist/react-datepicker.css'
import DatePicker, { registerLocale } from 'react-datepicker'
import { useLocaleState } from '@merchant-portal/merchant-portal-base'
import moment from 'moment'
import PropTypes from 'prop-types'
import sv from 'date-fns/locale/sv'
import da from 'date-fns/locale/da'
import nb from 'date-fns/locale/nb'
import fi from 'date-fns/locale/fi'
import { datePickerDateFormat } from '../../../util/dateUtils'
import styles from './DateRangePicker.module.scss'

registerLocale('sv', sv)
registerLocale('da', da)
registerLocale('fi', fi)
registerLocale('nb', nb)

const DateRangePicker = ({
  customDate,
  endDate,
  optionalMaxDate,
  selectDate,
  startDate,
  gapBetweenDates,
}) => {
  const { language } = useLocaleState()
  const maxDate = optionalMaxDate ? {} : { maxDate: moment().toDate() }
  const inputDateFormat = 'YYYY-MM-DD'

  return (
    <div className={styles.dateRangePicker}>
      <div className={gapBetweenDates && styles.gap}>
        <DatePicker
          id="from"
          name="from"
          locale={language}
          selectsStart
          startDate={moment(startDate).toDate()}
          endDate={moment(endDate).toDate()}
          dateFormat={datePickerDateFormat(language)}
          disabledKeyboardNavigation
          disabled={!customDate}
          selected={moment(startDate).toDate()}
          minDate={moment().subtract(10, 'y').toDate()}
          maxDate={moment().toDate()}
          onChange={value => {
            if (value && value <= moment(endDate).toDate()) {
              selectDate(endDate, moment(value).format(inputDateFormat))
            } else if (value && value > moment(endDate).toDate()) {
              const date = moment(value).format(inputDateFormat)
              selectDate(date, date)
            }
          }}
          dropdownMode="select"
        />
      </div>
      <DatePicker
        id="to"
        name="to"
        locale={language}
        selectsEnd
        startDate={moment(startDate).toDate()}
        endDate={moment(endDate).toDate()}
        dateFormat={datePickerDateFormat(language)}
        disabledKeyboardNavigation
        disabled={!customDate}
        selected={moment(endDate).toDate()}
        minDate={moment(startDate).toDate()}
        {...maxDate}
        onChange={value => {
          if (value >= moment(startDate).toDate()) {
            selectDate(moment(value).format(inputDateFormat), startDate)
          }
        }}
        dropdownMode="select"
      />
    </div>
  )
}

DateRangePicker.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  customDate: PropTypes.bool,
  selectDate: PropTypes.func.isRequired,
  optionalMaxDate: PropTypes.bool,
  gapBetweenDates: PropTypes.bool
}

DateRangePicker.defaultProps = {
  customDate: true,
  optionalMaxDate: false,
  gapBetweenDates: false
}

export default DateRangePicker
